import {
  type PaymentMethod,
  type PaymentMethodQueryParams,
  PaymentMethodQueryParamsSchema,
  paymentMethodsEndpoints,
} from "../../../api";
import { useStrapiList, type UseStrapiListOptions } from "../../../hooks/strapi";
import getErrorMessage from "../../../utils/getErrorMessage";
import handleError from "../../utils/handleError";

type UsePaymentMethodsProps = UseStrapiListOptions;

const usePaymentMethods = (props?: UsePaymentMethodsProps) => {
  const {
    items: paymentMethods,
    setItems: setPaymentMethods,
    refresh,
    isLoading,
    ...other
  } = useStrapiList<PaymentMethod>({
    ...props,
    load: (params) => {
      const parsed = PaymentMethodQueryParamsSchema.parse(params);
      return loadPaymentMethods(parsed);
    },
    onLoadError: (err: unknown) => {
      handleError(getErrorMessage(err, "Payment methods loading failed"));
    },
  });

  return {
    paymentMethods,
    setPaymentMethods,
    refresh,
    isLoading,
    ...other,
  };
};

export const loadPaymentMethods = async (params?: PaymentMethodQueryParams) => {
  try {
    return await paymentMethodsEndpoints.getPaymentMethods(params);
  } catch (err: unknown) {
    handleError(getErrorMessage(err, "Payment methods loading failed"));
  }
};

export default usePaymentMethods;
